import React, { useMemo } from "react";
import styles from "./ThemeItem.module.scss";
import { enumTheme } from "../../../interfaces/Site";
import { GeneratorSitePreviewScaleSetter } from "../../../views/GeneratorSite/components/GeneratorSitePreviewScaleSetter/GeneratorSitePreviewScaleSetter";
import { GeneratorSitePreview } from "../../../views/GeneratorSite/GeneratorSitePreview";
import { DesignTemplates } from "../../EditDesignTemplate/utils/designTemplates";
import { colorSchemeCollections } from "../../EditColorV2/utils/ColorSchemeCollections";

interface IProps {
    theme: enumTheme;
    setTheme: (theme: enumTheme) => void;
    currentTheme: string;
    calculateScale: boolean;
}

export const ThemeItem = (props: IProps) => {
    const isActive = () => {
        return props.currentTheme === props.theme;
    };

    // UseMemo to avoid rerendering
    const designTemplate = useMemo(() => {return {...DesignTemplates.STANDARD, theme: props.theme, colorScheme: colorSchemeCollections.LIGHT_GREEN.colorScheme}}, [props.theme])

    return (
        <div
            className={isActive() ? styles.wrapperActive : styles.wrapper}
            onClick={() => props.setTheme(props.theme)}
            data-test-id={"theme-selector-" + props.theme}
            data-test-theme={props.theme}
        >
            {props.calculateScale ? (
                <GeneratorSitePreviewScaleSetter scaleCssVariableName="--site-preview-scale-edit-theme" />
            ) : null}
            <div className={styles.inner}>
                <GeneratorSitePreview
                    designTemplate={designTemplate}
                    scaleCssVariableName="--site-preview-scale-edit-theme"
                />
            </div>
        </div>
    );
};
